export const tags = {
  en: [
    {
      label: "IR35",
      url_slug: "ir35",
    },
    {
      label: "DEI",
      url_slug: "dei",
    },
    {
      label: "Public Sector",
      url_slug: "public-sector",
    },
    {
      label: "Insurance",
      url_slug: "insurance",
    },
    {
      label: "Technology",
      url_slug: "technology",
    },
    {
      label: "Gravitas News",
      url_slug: "gravitas-news",
    },
    {
      label: "Videos",
      url_slug: "videos",
    },
    {
      label: "Employers",
      url_slug: "employers",
    },
    {
      label: "Candidate",
      url_slug: "candidate",
    },
  ],
};

export const findTag = ({ value, key = "url_slug", locale = "en" } = {}) => {
  return tags[locale].find((i) => i[key] === value) ?? null;
};
